const {
    nxlApi,
    electron: { show_window },
} = window;
export const parse = (url: string) => {
    let command = null;
    let productId = null;
    let partnerKey = null;
    const match = url.match('nxl://([^/]+)(/(.*))?');

    if (match && match.length > 1) {
        [, command] = match;

        if (match.length > 3 && match[3]) {
            [, , productId] = match;
            productId = productId.replace(/\\/gi, '');
            productId = productId.replace(/\//gi, '');
            const i = productId.indexOf('?');
            if (i !== -1) {
                const qs = productId.substring(i + 1, productId.length);
                productId = productId.substring(0, i);

                const kv = qs.split('&');

                for (let k = 0; k < kv.length; k++) {
                    const j = kv[k].indexOf('=');
                    if (j > 0) {
                        const key = kv[k].substring(0, j).toLowerCase();
                        const val = kv[k].substring(j + 1, kv[k].length);
                        if (key === 'partnerkey' && val.length !== 0) {
                            partnerKey = val;
                        }
                    }
                }
            }

            if (!productId) {
                productId = null;
            }
        }
    }
    return {
        command,
        productId,
        partnerKey,
    };
};

export const exec = (url: string) => {
    const { command, productId } = parse(url);
    switch (command) {
        case 'play':
        case 'launch':
            nxlApi.frontEnd.pub('playGame', { productId });
            break;
        case 'focus':
            show_window();
            break;
        case 'activate':
            nxlApi.frontEnd.pub('activate');
            break;
        case 'settings':
            nxlApi.frontEnd.pub('openPage', 206);
            break;
        case 'games':
            if (productId === null) {
                nxlApi.frontEnd.pub('openPage', 201);
            } else {
                nxlApi.frontEnd.pub('openPage', productId);
            }
            break;
        case 'account':
            nxlApi.frontEnd.pub('openPage', 210);
            break;
        default:
            return false;
    }
    return true;
};
